export const styles = {
    '@keyframes fadeFromTop': {
        from: {
            opacity: 0,
        },
        to: {
            opacity: 1,
        },
    },
    topHotelContainer: {
        animation: 'fadeFromTop 0.4s ease-in-out',
        animationFillMode: 'forwards',
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
